import React from 'react';
import PropTypes from 'prop-types';
import './Checkbox.styles.less';

class Checkbox extends React.Component {
  render() {

    const { label, value } = this.props;

    return (
      <React.Fragment>
        <input
          className="styled-checkbox"
          type="checkbox"
          value={value}
          {...this.props}
        />
        <label htmlFor=" ">{label}</label>
      </React.Fragment>
    );
  }
}
Checkbox.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.bool
};
export default Checkbox;
